// extracted by mini-css-extract-plugin
module.exports = {"indicator":"StatusIndicator_indicator__3ZWq5","wrapper":"StatusIndicator_wrapper__2R1wl","live_span":"StatusIndicator_live_span__1ksgM"};